export enum InvoiceStatus {
  Pending = 'pending',
  Posted = 'posted',
}
